import {useSelector} from 'react-redux';
import {MatchSimple} from '../utils/types';
import {AppState} from '../store/types';
import useMatchesActions, {UseMatchesActionsHook} from './useMatchesActions';

/**
 * Return type of the useMatches hook
 */
type UseMatchesResult = [
  {loading: boolean; data: {[key: string]: MatchSimple[]}; error?: string | boolean},
  UseMatchesActionsHook
];

/**
 * Selects the 'matches' state and sum it up into a referring object
 */
const matchesSelector = (state: AppState) => ({
  loading: state.matches.isFetching,
  data: state.matches.data || {},
  error: state.matches.didInvalidate ? state.matches.error : false,
});

/**
 * Wraps up the business logic of selecting the 'matches' state and its related actions.
 */
const useMatches = (): UseMatchesResult => {
  const state = useSelector(matchesSelector);
  const actions = useMatchesActions();

  return [state, actions];
};

export default useMatches;
